module.exports = __webpack_public_path__ + "d308073b/img/trash-icon.ff8201c7.svg";